import { Directive, ElementRef, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { fromEvent } from 'rxjs';
import { CVANotificationService } from '../../../services/cva-notification/cva-notification.service';
import { NotificationClassEnum } from '../../../models/notification-class.enum';
import { CVA_CONSTANTS } from '../../../util/constants';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';

@Directive({
    standalone: false,
    selector: '[cvaAuthPermCheck]',
    
})
export class CvaAuthPermCheckDirective implements OnInit {
  @Input() actionType!: 'disable' | 'hide' | 'notify' | 'drag-disable';
  @Input() moduleName!: string;
  @Input() permissionType!: string;

  constructor(
    private readonly  elementRef: ElementRef,
    private readonly  authLib: CustomLoginService,
    private readonly  cvaNotificationService: CVANotificationService,
    private readonly  renderer: Renderer2,
    @Optional() private readonly cdkDropList: CdkDropList,
    @Optional() private readonly  cdkDrag: CdkDrag
  ) { }

  ngOnInit(): void {
    this.authLib.IsAuthorized(this.moduleName, this.permissionType)
      .then((isPermitted) => {
        const elem = this.elementRef.nativeElement;
        if (!isPermitted) {
          if (this.actionType === 'disable') {
            elem.setAttribute('disabled', 'disabled');
            elem.style.pointerEvents = 'no-action';
          } else if (this.actionType === 'hide') {
            this.renderer.removeChild(this.renderer.parentNode(elem), elem);
          } else if (this.actionType === 'drag-disable') {
            if (this.cdkDropList) {
              this.cdkDropList.disabled = true;
            } else if (this.cdkDrag) {
              this.cdkDrag.disabled = true;
            }
          }
          const actionType = this.actionType;
          const notificationService = this.cvaNotificationService;
          fromEvent(elem, 'click', { capture: true })
            .subscribe((event) => {
              (<Event>event).stopPropagation();
              if (actionType === 'notify') {
                notificationService.showNotification(CVA_CONSTANTS.MESSAGE.UNAUTHORIZED, NotificationClassEnum.ERROR);
              }
            });
        }
      }).catch((error) => {
        console.error("Invalid permission!",error)
      })
  }

}
